export type { QuizCompleteScreenProps, QuizCtaConfig } from "./QuizCompleteScreen";
export { QuizCompleteScreen } from "./QuizCompleteScreen";
